module.exports = __webpack_public_path__ + "img/店铺排行4.20ac1e60.png";